


import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Breadcrumb, Form, Row, Col, Button, ModalTitle, Modal, FormControl } from 'react-bootstrap';
import axios from 'axios';
import { BASE_URL } from "../../config";
import Swal from 'sweetalert2';

const AddProductForm = () => {
  const [categories, setCategories] = useState([]);
  const [gstlist, setgstList] = useState([]);
  const [subCategories, setSubCategories] = useState([]);




  const [attributesData, setAttributesData] = useState([]); // Initialize as an empty array
  const [productInfo, setProductInfo] = useState({
    product_name: '',
    product_name_disp: '',
    product_description: '',
    sub_category_id: '',
    category_id: '',
    product_code: '',
    in_stock_status: '',
    product_sku: '',
    similar_products: '',
    gst_id: '',

  });
  const [productThumbnail, setProductThumbnail] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attributesSelection, setAttributesSelection] = useState({});


  const handleAttributeChange = (attributeId, value) => {
    setAttributesSelection((prev) => ({
      ...prev,
      [attributeId]: value,
    }));
  };

  const getCategory = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/category/all`);
      if (response.status === 200) {
        const { success, data } = response.data;
        if (success) {
          setCategories(data.categorys);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getGstList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/gst/all`);

      if (response.status === 200) {
        const { success, data } = response.data;
        if (success) {
          // setgstList(data.gst_list);
          const filteredList = data.gst_list.filter(item => item.display_status === true);

          setgstList(filteredList);



        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };





  const getSubCatCategory = async (category_id) => {
    try {
      setLoading(true);
      const response = await axios.post(`${BASE_URL}/sub-category/subcatbyid`, { category_id });
      if (response.status === 200) {
        const { success, data } = response.data;
        if (success) {
          setSubCategories(data);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };



  const getSubAttriByCatCategory = async (sub_category_id) => {
    try {
      setLoading(true);
      const response = await axios.post(`${BASE_URL}/attribute/get_attribute_by_sub_category_id`, {
        sub_category_id,
      });
      if (response.status === 200) {
        const { success, data } = response.data;
        if (success && Array.isArray(data.attributesWithValues)) {
          setAttributesData(data.attributesWithValues);
        } else {
          setAttributesData([]); // Reset to empty array if structure is unexpected
        }
      }
    } catch (error) {
      console.error(error);
      setAttributesData([]); // Reset to empty array on error
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    getCategory();
    getGstList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductInfo({
      ...productInfo,
      [name]: value,
    });

    if (name === 'category_id') {
      getSubCatCategory(value);
    }
    if (name === 'sub_category_id') {
      getSubAttriByCatCategory(value);
    }
  };

  const handleThumbnailChange = (e) => {
    setProductThumbnail(e.target.files[0]);
  };

  const handleImagesChange = (e) => {
    setProductImages(Array.from(e.target.files));
  };
  const [priceSizeData, setPriceSizeData] = useState([
    { attribute_value_id: '', product_MRP: '', product_MSP: '' }, // Default entry
  ]);



  const addPriceSizeEntry = () => {
    setPriceSizeData(prevData => [
      ...prevData,
      { attribute_value_id: '', product_MRP: '', product_MSP: '' }, // Initialize with empty values
    ]);
  };
  const removePriceSizeEntry = (index) => {
    if (priceSizeData.length > 1) { // Check if more than one row exists
      const newData = priceSizeData.filter((_, i) => i !== index);
      setPriceSizeData(newData);
    } else {
      alert("At least one price entry must remain."); // Optional alert
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!productInfo.category_id) {
      Swal.fire("Error", "Please select category", "error");
      return;
    }

    if (!productInfo.sub_category_id) {
      Swal.fire("Error", "Please select sub category", "error");
      return;
    }

    if (!productInfo.product_name) {
      Swal.fire("Error", "Please enter product name", "error");
      return;
    }

    if (!productThumbnail) {
      Swal.fire("Error", "Please upload product thumbnail", "error");
      return;
    }

    if (!productImages || productImages.length === 0) {
      Swal.fire("Error", "Please upload product images", "error");
      return;
    }

    // Attribute validation
    if (!attributesData || attributesData.length === 0) {
      Swal.fire(
        "Error",
        "Please add attribute and value for this sub category",
        "error"
      );
      return;
    }

    // Normal attributes validation (except size attribute 2)
    const normalAttributes = attributesData.filter(
      (attr) => attr.attribute_id !== 2
    );

    for (const attr of normalAttributes) {
      if (!attributesSelection[attr.attribute_id]) {
        Swal.fire(
          "Error",
          `Please select ${attr.attribute_name}`,
          "error"
        );
        return;
      }
    }

    // Size attribute validation (attribute_id = 2)
    const sizeAttribute = attributesData.find(
      (attr) => attr.attribute_id === 2
    );

    if (sizeAttribute) {
      if (!priceSizeData || priceSizeData.length === 0) {
        Swal.fire(
          "Error",
          "Please add at least one size with price",
          "error"
        );
        return;
      }

      for (const item of priceSizeData) {
        if (
          !item.attribute_value_id ||
          !item.product_MRP ||
          !item.product_MSP
        ) {
          Swal.fire(
            "Error",
            "Please fill Size, MRP and MSP properly",
            "error"
          );
          return;
        }
      }
    }

    // ================= VALIDATION END =================

    setLoading(true);

    const formData = new FormData();

    // Append product info
    for (const key in productInfo) {
      formData.append(key, productInfo[key]);
    }

    // Thumbnail
    if (productThumbnail) {
      formData.append("product_thumbnail", productThumbnail);
    }

    // Images
    productImages.forEach((image) => {
      formData.append("product_images", image);
    });

    // Attributes array
    const attributeValuesArray = [];

    for (const [attributeId, value] of Object.entries(
      attributesSelection
    )) {
      attributeValuesArray.push({
        attribute_id: attributeId,
        attribute_value_ids: [value],
      });
    }

    // Size attribute
    const attributeId2Data = attributesData.find(
      (attr) => attr.attribute_id === 2
    );

    if (attributeId2Data) {
      attributeValuesArray.push({
        attribute_id: 2,
        attribute_value_ids: priceSizeData.map(
          (item) => item.attribute_value_id
        ),
        price_size: priceSizeData.map((item) => ({
          attribute_value_id: item.attribute_value_id,
          product_MRP: item.product_MRP,
          product_MSP: item.product_MSP,
        })),
      });
    }

    formData.append(
      "attributeValues",
      JSON.stringify(attributeValuesArray)
    );

    try {
      const response = await axios.post(
        `${BASE_URL}/product/add-product`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Product added successfully!",
        }).then(() => {
          window.location.reload();
        });

        // Reset
        setProductInfo({
          product_name: "",
          product_name_disp: "",
          product_description: "",
          sub_category_id: "",
          category_id: "",
          product_code: "",
          in_stock_status: "",
          product_sku: "",
          similar_products: "",
          gst_id: "",
        });

        setProductThumbnail(null);
        setProductImages([]);
        setAttributesSelection({});
        setPriceSizeData([]);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Failed to add product.",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while adding the product.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className='container-fluid admin-input'>
        <Breadcrumb className="px-4 py-3">
          <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
          <Breadcrumb.Item>Products</Breadcrumb.Item>
          <Breadcrumb.Item active>Add</Breadcrumb.Item>
        </Breadcrumb>
        <section className="content">
          <div className="container-fluid">
            <Card>
              <Card.Header>
                <h4>Add Product</h4>
              </Card.Header>
              <CardBody>
                <form onSubmit={handleSubmit}>
                  <div className='row'>
                    <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                      <Form.Label>Select Category</Form.Label>
                      <Form.Select
                        name="category_id"
                        value={productInfo.category_id}
                        onChange={handleChange}
                        required
                      >
                        <option value=""> -- Select -- </option>
                        {categories.map((category) => (
                          <option key={category.category_id} value={category.category_id}>
                            {category.category_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                      <Form.Label>Select Sub Category</Form.Label>
                      <Form.Select
                        name="sub_category_id"
                        value={productInfo.sub_category_id}
                        onChange={handleChange}
                        required
                      >
                        <option value="">-- Select --</option>
                        {subCategories.map((subCategory) => (
                          <option key={subCategory.sub_category_id} value={subCategory.sub_category_id}>
                            {subCategory.sub_category_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3 col-sm-3">
                      <Form.Label>Product Name</Form.Label>
                      <Form.Control type="text"
                        name="product_name"
                        value={productInfo.product_name}
                        onChange={handleChange}
                        placeholder=""
                        required />
                    </Form.Group>

                    <Form.Group className="mb-3 col-sm-3">
                      <Form.Label>Dispaly Name</Form.Label>
                      <Form.Control type="text"
                        name="product_name_disp"
                        value={productInfo.product_name_disp}
                        onChange={handleChange}
                        placeholder=""
                        required />
                    </Form.Group>


                    <Form.Group className="mb-3 col-sm-3">
                      <Form.Label>Product Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="product_code"
                        value={productInfo.product_code}
                        onChange={handleChange}
                        placeholder=""
                        required />
                    </Form.Group>

                    <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                      <Form.Label>Stock</Form.Label>
                      <Form.Select
                        name="in_stock_status"
                        value={productInfo.in_stock_status}
                        onChange={handleChange}
                        required
                      >
                        <option value="" className='text-danger'>-- Select --</option>
                        <option value="In Stock">In Stock</option>
                        <option value="Out Of Stock">Out Of Stock</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3 col-sm-3">
                      <Form.Label>Product SKU</Form.Label>
                      <Form.Control
                        type="text"
                        name="product_sku"
                        value={productInfo.product_sku}
                        onChange={handleChange}
                        placeholder=""
                        required />
                    </Form.Group>

                    <Form.Group className='col-sm-3 pb-4' controlId="formGridState">
                      <Form.Label>GST %</Form.Label>
                      <Form.Select
                        name="gst_id"
                        value={productInfo.gst_id}
                        onChange={handleChange}
                        required
                      >
                        <option value=""> -- Select -- </option>
                        {gstlist.map((gst) => (
                          <option key={gst.gst_id} value={gst.gst_id}>
                            {gst.gst_percent} %
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3 col-sm-3">
                      <Form.Label>Product Thumbnail</Form.Label>
                      <Form.Control
                        type="file"
                        name="product_thumbnail"
                        onChange={handleThumbnailChange}
                        accept="image/*"
                        required />
                    </Form.Group>

                    <Form.Group className="mb-3 col-sm-3">
                      <Form.Label>Product Images (Multiple)</Form.Label>
                      <Form.Control
                        type="file"
                        name="product_images"
                        onChange={handleImagesChange}
                        accept="image/*"
                        multiple
                        required />
                    </Form.Group>



                    {/* attributes */}
                    {/* Display attributes other than attribute_id === 2 */}
                    {attributesData
                      .filter((attribute) => attribute.attribute_id !== 2)
                      .map((attribute, index) => (
                        <Form.Group className="mb-3 col-sm-3" key={index}>
                          <Form.Label className='text-capitalize'>{attribute.attribute_name}</Form.Label>
                          <Form.Select

                            required
                            value={attributesSelection[attribute.attribute_id] || ''}
                            onChange={(e) => handleAttributeChange(attribute.attribute_id, e.target.value)}

                          >
                            <option>--select--</option>
                            {attribute.attributeValues.map((attvalue) => (
                              <option key={attvalue.attribute_value_id} value={attvalue.attribute_value_id} className='text-capitalize'>
                                {attvalue.attribute_value}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      ))
                    }

                    {/* when the get  attribute 2 than this is also call */}
                    {attributesData
                      .filter((attribute) => attribute.attribute_id === 2)
                      .map((attribute) => (
                        <Form.Group className="mb-3 mt-3 col-sm-6" key={attribute.attribute_id}>
                          <div style={{ background: "#f1f1f1", padding: "16px 11px" }}>
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col" className='text-capitalize pt-0'>     <Form.Label>{attribute.attribute_name}</Form.Label> </th>
                                  <th scope="col" className='pt-0'> <Form.Label>Product MRP </Form.Label> </th>
                                  <th scope="col" className='pt-0'><Form.Label>Product MSP </Form.Label> </th>
                                  <th scope="col" className='pt-0'></th>
                                </tr>
                              </thead>
                              <tbody>
                                {priceSizeData.map((item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <select
                                        className='form-control-sm form-control'
                                        value={item.attribute_value_id}
                                        required
                                        onChange={(e) => {
                                          const newData = [...priceSizeData];
                                          newData[index].attribute_value_id = e.target.value;
                                          setPriceSizeData(newData);
                                        }}
                                      >
                                        <option>--select--</option>
                                        {attribute.attributeValues.map((attvalue) => (
                                          <option key={attvalue.attribute_value_id} value={attvalue.attribute_value_id}>
                                            {attvalue.attribute_value}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td>
                                      <Form.Control
                                        type="number"
                                        className='form-control-sm'
                                        value={item.product_MRP}
                                        onChange={(e) => {
                                          const newData = [...priceSizeData];
                                          newData[index].product_MRP = e.target.value;
                                          setPriceSizeData(newData);
                                        }}
                                        required
                                        placeholder='Product MRP'
                                      />
                                    </td>
                                    <td>
                                      <Form.Control
                                        type="number"
                                        className='form-control-sm'
                                        value={item.product_MSP}
                                        onChange={(e) => {
                                          const newData = [...priceSizeData];
                                          newData[index].product_MSP = e.target.value;
                                          setPriceSizeData(newData);
                                        }}
                                        required
                                        placeholder='Product MSP'
                                      />
                                    </td>
                                    <td>
                                      <Button variant="white" className='btn-sm text-danger' onClick={() => removePriceSizeEntry(index)}><b>X</b></Button>
                                    </td>
                                  </tr>
                                ))}

                              </tbody>

                            </table>
                            <div className='text-end'>
                              <Button variant="dark" className='btn-sm' onClick={addPriceSizeEntry}>Add Size</Button>
                            </div>
                          </div>
                        </Form.Group>

                      ))
                    }


                    <Form.Group className='col-sm-12 pb-4' controlId="exampleForm.ControlTextarea1">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="product_description"
                        value={productInfo.product_description}
                        onChange={handleChange}
                        placeholder=""
                      />
                    </Form.Group>
                  </div>
                  <div className='text-center mt-3 mb-3'>
                    <Button variant="primary" className='px-5 py-2' type="submit" disabled={loading}>
                      {loading ? 'Submitting...' : 'Add Product'}
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </div>
        </section>
      </div>




    </>
  );
};

export default AddProductForm;





